<template>
  <div class="tablaListado">
    <a-table
      :columns="columnsTable"
      :data-source="basesInfo.items"
      row-key="id"
      size="middle"
      :pagination="basesInfo.pagination"
      :scroll="scrollStyle"
      @change="handleTableChange"
    >
      <template v-slot:customBases
        >Nombre de la base
        <a-tooltip>
          <template v-slot:title> Ordenar </template>
          <SwapOutlined :rotate="90" />
        </a-tooltip>
      </template>
      <template v-slot:customName
        >Nombre de la campaña
        <a-tooltip>
          <template v-slot:title> Ordenar </template>
          <SwapOutlined :rotate="90" />
        </a-tooltip>
      </template>
      <template v-slot:customEntity
        >Empresa
        <a-tooltip>
          <template v-slot:title> Ordenar </template>
          <SwapOutlined :rotate="90" />
        </a-tooltip>
      </template>

      <template #entity="{ record }">
        <div class="name">
          <div
            v-if="record.entity.logo"
            class="name__logo"
            :style="`background-image: url('${record.entity.logo}')`"
          />
          <div v-else class="name__logo name__logo--empty" />
          <span>{{ record.entity.name }}</span>
        </div>
      </template>

      <template #name="{ text }">
        <span>
          <a-tooltip placement="bottom">
            <template v-slot:title> {{ text }} </template>
            <span>{{ text }}</span>
          </a-tooltip>
        </span>
      </template>

      <template #date_start="{ text }">
        <span>
          {{ getDateWithTwoDigitsFormat(text) }}
        </span>
      </template>
      <template #date_finish="{ text }">
        <span>
          {{ getDateWithTwoDigitsFormat(text) }}
        </span>
      </template>
      <template #actionScoped="{ record }">
        <span class="cell--actions">
          <a-switch
            :checked="record.status === UserStatus.active"
            class="switch"
            size="small"
            @change="handleStatusChange($event, record, 'reactivate')"
          />
          <a-tooltip>
            <template v-slot:title> Dashboard </template>
            <a class="link--edit" @click="handleShowModalDashboard($event, record, 'dashboard')"
              ><PieChartOutlined
            /></a>
          </a-tooltip>
          <a-tooltip v-if="record.status === UserStatus.active">
            <template v-slot:title> Editar </template>
            <a class="link--edit" @click="handleShowModalWithRecord($event, record, 'edit')">
              <EditOutlined />
            </a>
          </a-tooltip>
          <a-tooltip v-if="record.status === UserStatus.inactive">
            <template v-slot:title> Editar </template>
            <a
              class="edit__disabled"
              @click="handleShowModalWithRecord($event, record, 'edit')"
              disabled
            >
              <EditOutlined />
            </a>
          </a-tooltip>

          <a-tooltip>
            <template v-slot:title> Eliminar </template>
            <a class="link--edit" @click="handleShowModalWithRecord($event, record, 'delete')"
              ><DeleteOutlined
            /></a>
          </a-tooltip>
        </span>
      </template>
    </a-table>

    <ModalEditBase
      v-if="record && openModalType === 'edit'"
      @onCloseModal="handleCloseModalWithRecord"
      :record="record"
      :type-business="user.customer ? user.customer.type_business : 1"
    />
    <ModalDashboardBase
      :key="keyDashboard"
      v-if="record && openModalType === 'dashboard'"
      @onCloseModal="handleCloseModalWithRecord"
      :record="record"
      :name="nameBase"
      :base="base"
    />
    <ModalDeleteBase
      :record="record"
      v-if="record && openModalType === 'delete'"
      @onCloseModal="handleCloseModalWithRecord"
    />
    <ModalReactivateBase
      v-if="record && openModalType === 'reactivate'"
      @onCloseModal="handleCloseModalWithRecord"
      :record="record"
      @onReactiveBase="handleReactiveBase(record)"
    />
  </div>
</template>

<script>
import ModalDashboardBase from "@/app/entities/components/modals/bases/modaldasboard/ModalDashboardBase.vue";
import ModalDeleteBase from "../modals/bases/modalBases/ModalDeleteBase.vue";
import ModalEditBase from "@/app/entities/components/modals/bases/modalBases/ModalEditBase.vue";
import ModalReactivateBase from "@/app/entities/components/modals/bases/modalBases/ModalReactivateBase.vue";
import { UserStatus } from "@/app/shared/utils/enums";

import { basesTablecolumns } from "@/app/entities/utils/constants";
import { defineComponent, createVNode } from "vue";
import {
  DeleteOutlined,
  SwapOutlined,
  PieChartOutlined,
  EditOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons-vue";
import { getDateWithTwoDigitsFormat } from "@/app/shared/utils/dates";
import { fetchDashboardByBase } from "../../services";

import { useScrollResize } from "@/app/shared/composables/useScrollResize";

export default defineComponent({
  name: "TablaBases",
  components: {
    ModalEditBase,
    DeleteOutlined,
    SwapOutlined,
    ModalDashboardBase,
    PieChartOutlined,
    EditOutlined,
    ModalDeleteBase,
    ModalReactivateBase,
  },
  setup() {
    const { scrollStyle } = useScrollResize();

    return { scrollStyle };
  },
  data() {
    return {
      columns: basesTablecolumns,
      record: null,
      openModalType: "",
      nameBase: "",
      keyDashboard: 0,
      UserStatus,
    };
  },
  computed: {
    user() {
      return this.$store.getters["getDataUser"];
    },
    basesInfo() {
      return this.$store.getters["getBasesInfo"];
    },
    columnsTable() {
      // const column = columnsFixedTableLeft(this.columns);
      // return column;
      return this.columns;
    },
    selectedEntity() {
      return this.$store.getters["getSelectedEntity"];
    },
    selectedPortfolio() {
      return this.$store.getters["getSelectedPortfolio"];
    },
  },
  created() {
    this.handleFetchBases(0, { entity: this.selectedEntity, portfolio: this.selectedPortfolio });
  },
  methods: {
    handleCloseModalWithRecord() {
      this.record = null;
      this.openModalType = "";
    },
    async handleShowModalDashboard(event, record, type) {
      this.keyDashboard++;
      this.nameBase = record.name;
      const response = await fetchDashboardByBase(record.id);
      this.base = record;
      this.record = response.data;
      this.openModalType = type;
    },
    handleShowModalWithRecord(event, record, type) {
      this.record = record;
      this.openModalType = type;
    },
    getDateWithTwoDigitsFormat(text) {
      return getDateWithTwoDigitsFormat(text);
    },
    handleTableChange(pagination) {
      this.handleFetchBases(pagination);
    },
    handleFetchBases(pagination, filters) {
      this.$store.dispatch("fetchAllBases", {
        filters,
        pagination: pagination,
      });
    },
    handleStatusChange(checked, record, type) {
      if (checked) {
        this.record = record;
        this.openModalType = type;
      } else {
        this.handleConfirmationInactive(record);
      }
    },

    handleConfirmationInactive(record) {
      this.$confirm({
        title: `¿Estás seguro de desactivar la base ”${record.name}”?`,
        content:
          "Se desactivarán las estrategias asociadas a esta base y los tickets se finalizarán automáticamente.",
        icon: createVNode(QuestionCircleOutlined),
        onOk: () => {
          this.$store.dispatch("changeBaseStatus", record);
          this.$message.success(`Se ha desactivado la base ${record.name}`);
        },
        centered: true,
        okText: "Desactivar",
        cancelText: "Cancelar",
      });
    },
  },
});
</script>

<style lang="sass" scoped>
:deep(.ant-table-thead > tr > th)
  // padding: 10px !important
:deep(.ant-table-thead > tr > th .ant-table-column-sorter)
  display: none
.name
  display: flex
  align-items: center
  position: relative

  &__logo
    display: block
    width: 25.63px
    height: 25.24px
    background-size: cover
    background-position: center
    border-radius: 50%
    margin-right: 12px

    &--empty
      background-image: url('../../assets/briefcase-blue.svg')

.switch
  margin-right: 8px
  margin-top: 2px

.cell--actions
  display: flex

.link--edit
  margin-right: 13px

.edit__disabled
  margin-right: 13px
  color: $gray-6
</style>
